/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { Button } from "@nextui-org/button";
import { Snippet } from "@nextui-org/snippet";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useParams } from "react-router-dom";
import { apiService } from "../services/apiService";
import { useDispatch } from "react-redux";
import { closeModal } from "../features/modalSlice";

// Inside ModalShareLink


const ModalShareLink: React.FC = () => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [shareId, setShareId] = useState<string>("");
  const location = useLocation();
  const { chatID } = useParams();
  const currentURL = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  const [halfUrl] = currentURL.split("/chat/");
  console.log("half url", halfUrl);
  const id = Number(chatID);
  // Trigger animation on modal open
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Custom outside click handler
  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        modalRef.current &&
        e.target instanceof Node &&
        !modalRef.current.contains(e.target)
      ) {
        dispatch(closeModal("ModalShareLink"));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);
  // Prevent closing modal on inner clicks
  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // get Share Data
  const fetchShareLink = async (new_id: number) => {
    // console.log("new_id: ", new_id);
    try {
      const response = await apiService.shareChat(new_id); // Call the API service
      if (response?.status === 200) {
        // console.log(" >> share data", (response as any).data.data);
        setShareId((response as any)?.data?.id);
        toast.success("Chat Link Generated", {
          className: "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      }
    } catch (error) {
      toast.error("Error loading share link.", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };

  // Handle save button click
  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await apiService.postShareChat(id);
      const respId = (response as any)?.data?.id;
      if (respId) {
        fetchShareLink(respId);
      }
      setLoading(false);
      // Close modal after successful sharing
      // onClose();
    } catch (error) {
      setLoading(false);
      toast.error("Error sharing chat", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };
  return (
    
    <div
      aria-hidden="true"
      className="fixed inset-0 flex justify-center items-center md:backdrop-blur-[auto] backdrop-blur-10 z-[70]"
      // ref={overlayRef}
    >
      <div
        aria-hidden="true"
        className={`md:px-6 px-3 py-6 md:bg-none md:bg-transparent dark:bg-chatDarkBg/60 bg-lightBg/60 md:mx-auto mx-2 ${
          isVisible ? "scale-100 opacity-100 translate-y-0" : "scale-95 opacity-0 translate-y-4"
        } custom-modal-bg rounded-3xl max-w-[37.5rem] w-full relative backdrop-blur-[42px]`}
        ref={modalRef}
        onClick={handleModalClick}
      >
        <div className="">
          <h2 className="pb-3 text-xl text-black dark:text-white font-ProximaLight">
            Share public link to chat
          </h2>
          <p className="text-sm">
            Your name, custom instructions, and any messages you add after sharing stay private.
          </p>
        </div>
        {loading && <p>Generating link...</p>}
        {shareId ? (
          <div className="md:bg-transparent dark:bg-chatDarkBg/50 bg-lightBg/50 rounded-[40px] border-[0.2px] dark:border-gray-300 border-[#5f829f73] mt-6 md:p-2 flex justify-between gap-5 items-center">
            <Snippet
              symbol={false}
              classNames={{
                pre: "text-black text-center dark:text-white md:text-xl bg-transparent font-ProximaLight",
                content: "bg-transparent",
                base: "bg-transparent mx-auto",
                copyButton: "dark:bg-black/20 bg-white/60",
              }}
            >{`${halfUrl}/share/${shareId}`}</Snippet>
          </div>
        ) : (
          <div className="rounded-[40px] border-[0.2px] dark:border-gray-300 border-[#5f829f73] mt-6 p-2 flex justify-between gap-5 items-center">
            <p className="md:text-xl pl-3 select-none w-[50%] overflow-hidden">{`${halfUrl}/share/...`}</p>
            <Button
              onPress={handleSave}
              isLoading={loading}
              className="backdrop-blur-[42px] h-full md:py-3 py-1.5 rounded-[20px] bg-white/10 ml-auto w-full max-w-36 border-[#5f829f73] border-[0.2px] text-black dark:text-white text-sm font-ProximaLight"
            >
              {loading ? <span className="block mx-auto loader-dots"></span> : "Share"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalShareLink;
